import { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo3D from "@/components/Logo3D";
import { useI18n } from "@/lib/i18n";
import { useContent } from "@/lib/content";

export default function Footer() {
  const { t } = useI18n();
  const { content } = useContent();
  const c = content?.contacts;
  const banner = content?.footer_banner;

  useEffect(() => {
    if (typeof document === "undefined") return;
    // Apply only once content has loaded so we don't clobber the early bootstrap
    // script's decision in index.html during initial paint.
    if (!banner) return;
    document.body.setAttribute("data-fk-banner", banner.enabled === false ? "off" : "on");
  }, [banner]);

  return (
    <footer className="border-t border-border bg-muted/30 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <Logo3D size={32} />
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-3 text-sm">
          <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-privacy">{t("pages.privacy")}</Link>
          <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-terms">{t("pages.terms")}</Link>
          <Link to="/refund" className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-refund">{t("pages.refund")}</Link>
        </div>
        <div className="text-xs text-muted-foreground">
          {c?.copyright || `© ${new Date().getFullYear()} TEMPEO`}
        </div>
      </div>
    </footer>
  );
}
